/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 03/05/2025
 */
import {defineAsyncComponent, markRaw} from "vue";

export const customFieldComponents = {
    paragraph: defineAsyncComponent(() =>
        import('./compParagraph.vue').then(res => markRaw(res.default))
    ),
    hline: defineAsyncComponent(() =>
        import('./compHorizontalLine.vue').then(res => markRaw(res.default))
    ),
    image: defineAsyncComponent(() =>
        import('./compImage.vue').then(res => markRaw(res.default))
    ),
    youtube: defineAsyncComponent(() =>
        import('./compVideoYoutube.vue').then(res => markRaw(res.default))
    )
}
